import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TimelineTask } from '../../../../../shared/models/activity.model';
import { CommonModule } from '@angular/common';


// MINI MODAL TO SHOW DETAIL FROM TASKS
@Component({
  selector: 'app-mini-modal-detail-task',
  imports: [CommonModule],
  templateUrl: './mini-modal-detail-task.html'
})
export class MiniModalDetailTaskComponent {
  @Input() tasks: TimelineTask[] = [];
  @Input() position!: { top: number; left: number };
  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.close.emit();
  }
}
